import "./MarketingTab.css";

import { TextWithLineBreaks } from "../../../Components/TextWithLineBreaks";
import RoundedBox from "../../../Components/RoundedBox/RoundedBox";


function MarketingTab({ }) {
    const CustomRoundBoxStyle = {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'transparent',
        border: '2px solid #F2F3F5',
        width: '350px',
        padding: '20px 0'
    };

    return (
        <div className="marketing-tab">
            <div className="marketing-tab-title">
                기획 출판, 에이콘이 마케팅까지 ‘기획’합니다
            </div>

            <div className="marketing-tab-row">
                <div className="marketing-tab-labelled-box">
                    <div className="marketing-tab-box-label">
                        출판사의 마케팅 역할
                    </div>
                    <div className="marketing-tab-box-contents">
                        <TextWithLineBreaks text={"- 타겟 분석: 주요 독자층 및 구매 패턴 분석 \n- 채널 선정: 효과적인 홍보 채널 선택\n- 콘텐츠 기획: 홍보 콘텐츠 및 이벤트 기획\n- 예산 배분: 마케팅 예산 최적 분배"} />
                    </div>
                </div>
                <div className="marketing-tab-labelled-box">
                    <div className="marketing-tab-box-label">
                        저작자의 마케팅 역할
                    </div>
                    <div className="marketing-tab-box-contents">
                        <TextWithLineBreaks text={"- 협조 의무: 인터뷰, 기고, 이벤트 참여 \n- 개인 홍보: SNS, 개인 네트워크 활용 권장 \n- 전문성 발휘: 관련 분야 강연, 기고 등 \n- 피드백: 마케팅 효과 및 독자 반응 공유"} />
                    </div>
                </div>
            </div>

            <div className="marketing-tab-spacer" />

            <div className="marketing-tab-title">
                출판 마케팅, 효과는 이렇게 확인합니다
            </div>

            <div className="marketing-tab-grid">
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="marketing-tab-box-title">
                        판매량
                    </div>
                    <div className="marketing-tab-box-desc">
                        목표 대비 실제 판매 성과
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="marketing-tab-box-title">
                        인지도
                    </div>
                    <div className="marketing-tab-box-desc">
                        온라인 검색량, 언급량 증가
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="marketing-tab-box-title">
                        독자 반응
                    </div>
                    <div className="marketing-tab-box-desc">
                        리뷰, 평점, SNS 반응
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="marketing-tab-box-title">
                        매체 노출
                    </div>
                    <div className="marketing-tab-box-desc">
                        언론 보도, 인터뷰 횟수
                    </div>
                </RoundedBox>
            </div>
        </div>
    );
}

export default MarketingTab;